import {
  BackgroundTask,
  BackgroundTaskKind,
} from "@/components/state/backgroundTasks/backgroundTasksSlice";

export enum TaskChannelMessageType {
  STARTED = "TASK_STARTED_EXTERNALLY",
  COMPLETED = "TASK_COMPLETED_NOTIFIED",
  TRY_SHOW_MODAL = "TRY_SHOW_MODAL_IN_ACTIVE_TAB"
}

export interface TaskChannelMessage {
  type: TaskChannelMessageType;
  taskId: string;
  description?: string;
  kind?: BackgroundTaskKind;
  task?: BackgroundTask 
  resData?: any;
}
